<template>
  <div class="tabs-html-container">
    <v-tabs
      v-if="!isMobile"
      v-model="tab"
      :vertical="isVerticalTabs"
      :hide-slider="isVerticalTabs"
      active-class="active-html-tab"
      class="html-tabs"
    >
      <v-tab
        :class="{ 'justify-start pl-0': isVerticalTabs }"
        v-for="(tab, index) in content"
        :key="index"
      >
        {{ tab.name }}
      </v-tab>
      <v-tab-item
        :reverse-transition="true"
        v-for="(tab, index) in content"
        :key="index"
      >
        <div v-html="tab.content" class="wysiwyg-tab" />
      </v-tab-item>
    </v-tabs>
    <tabs-html-mobile v-if="isMobile" :tabs="content" />
  </div>
</template>
<script>
import { TabsOrientation } from '@/models/enums'
import TabsHtmlMobile from './ContentType.TabsHtmlMobile'
export default {
  name: 'TabsHtml',
  components: { TabsHtmlMobile },
  props: {
    model: Object
  },
  data: () => ({
    tab: null
  }),
  computed: {
    content: function () {
      return this.model.content
    },
    isVerticalTabs: function () {
      return this.model.metadata.orientation === TabsOrientation.Vertical
    },
    isMobile: function () {
      return this.$vuetify.breakpoint.mobile
    }
  }
}
</script>
<style lang="scss" >
div.content.tabs-html-container {
  padding: 2rem 0;
}
.wysiwyg-tab {
  font-size: 1.6rem;
}
.html-tabs.v-tabs.v-tabs--vertical {
  .v-tabs-items {
    padding-left: 2rem;
  }
  & > .v-tabs-bar {
    border-right: solid 4px #549ec7;
    min-width: 410px;

    div.v-tab {
      font-size: 1.6rem;
      text-transform: none;
      letter-spacing: 0;
      color: black;
      transition: all 0.3s ease-out;
      min-width: 410px;

      &.active-html-tab {
        font-size: 2.7rem;
        text-align: left;
        text-wrap: none;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
